import { toHumanReadable } from 'beam/dist/utils/duration'
import { msToHHMMSS } from 'beam/dist/utils/time'
import moment from 'moment/moment'
import 'moment-timezone'
import PropTypes from 'prop-types'
import Tooltip from 'beam/dist/Tooltip'
import withStyles from 'beam/dist/styles'
import { Rect } from 'victory'
import { SOURCE_TYPE } from '../../SpeechPanel/speech.constants'

const styles = theme => ({
  phrase: {
    marginBottom: theme.spacing(0.5),
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
    paddingBottom: theme.spacing(0.5),
    fontSize: theme.typography.pxToRem(12),
  },
  label: {
    marginRight: theme.spacing(0.5),
    color: theme.palette.grey[300],
  },
})

const parseSpeechHit = (
  { contactOffset, duration, confidence, source, phrase, category, channel },
  size,
  heightUnitsPerMs,
  containerWidth,
  eventMaxWidth,
  backgroundColor,
) => ({
  start: msToHHMMSS(contactOffset),
  startMs: contactOffset,
  duration: toHumanReadable(moment.duration(duration)),
  timePosition: Math.round(contactOffset * heightUnitsPerMs),
  offsetPosition: size,
  width: confidence * (eventMaxWidth / 100) - 1,
  durationLength: Math.max(Math.round(duration * heightUnitsPerMs), 1),
  backgroundColor,

  //Will be translated
  source: source === SOURCE_TYPE.PHONETICS ? SOURCE_TYPE.PHONETICS : SOURCE_TYPE.TRANSCIRPTION,
  phrase,
  category,
  confidence: `${confidence}`,
  channel,
})

const SpeechHit = ({
  event,
  heightUnitsPerMs,
  t,
  classes,
  theme,
  size,
  containerWidth,
  eventMaxWidth = containerWidth,
  setTime,
  showPhrase,
}) => {
  const {
    start,
    startMs,
    duration,
    timePosition,
    //offsetPosition,
    //durationLength,
    width,
    backgroundColor,
    source,
    phrase,
    category,
    confidence,
    channel,
  } = parseSpeechHit(event, size, heightUnitsPerMs, containerWidth, eventMaxWidth, theme.palette.color.green[500])

  return (
    <Tooltip
      disableFocusListener
      title={(() => (
        <div className={classes.popper}>
          <div className={classes.phrase}>{phrase}</div>
          <div>
            <span className={classes.label}>{t('category')}:</span> {category}
          </div>
          <div>
            <span className={classes.label}>{t('source')}:</span> {t(source)}
          </div>
          <div>
            <span className={classes.label}>{t('start')}:</span> {start}
          </div>
          <div>
            <span className={classes.label}>{t('duration')}:</span> {duration}
          </div>
          {source === SOURCE_TYPE.PHONETICS ? (
            <div>
              <span className={classes.label}>{t('confidence')}:</span> {confidence}
            </div>
          ) : null}
          <div>
            <span className={classes.label}>{t('channel')}:</span> {channel}
          </div>
        </div>
      ))()}
    >
      <g onClick={() => setTime(startMs)} style={{ cursor: 'pointer' }}>
        <Rect
          x={0}
          y={timePosition}
          width={width}
          height={size}
          style={{
            fill: backgroundColor,
          }}
        />
        {showPhrase && (
          <text x={2} y={timePosition + 12} style={{ fontSize: '12px' }}>
            {phrase}
          </text>
        )}
      </g>
    </Tooltip>
  )
}

SpeechHit.propTypes = {
  event: PropTypes.object.isRequired,
  heightUnitsPerMs: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  size: PropTypes.number.isRequired,
  setTime: PropTypes.func,
  showPhrase: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  containerWidth: PropTypes.number,
  eventMaxWidth: PropTypes.number,
}

SpeechHit.defaultProps = {
  setTime: () => {},
  showPhrase: false,
}

export { SpeechHit as UnstyledSpeechHit }

export default withStyles(styles)(SpeechHit)
